import React from 'react';
import classnames from 'classnames';
import noop from '../utils/noop';
import s from './RadioButton.scss';
var RadioButton = function (_a) {
    var name = _a.name, _b = _a.onChange, onChange = _b === void 0 ? noop : _b, value = _a.value, className = _a.className, checked = _a.checked, children = _a.children;
    return (React.createElement("label", { className: classnames(s['option'], className) },
        React.createElement("input", { type: "radio", name: name, value: value, onChange: onChange, checked: checked }),
        children));
};
RadioButton.displayName = 'RadioButton';
export default RadioButton;
//# sourceMappingURL=RadioButton.js.map